import { render, staticRenderFns } from "./CmgUnsupportedBrowserHeader.vue?vue&type=template&id=b5fcf742&scoped=true&lang=pug&"
import script from "./cmg-unsupported-browser-header.ts?vue&type=script&lang=ts&"
export * from "./cmg-unsupported-browser-header.ts?vue&type=script&lang=ts&"
import style0 from "./CmgUnsupportedBrowserHeader.vue?vue&type=style&index=0&id=b5fcf742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fcf742",
  null
  
)

export default component.exports